<template>
    <div id="JurisdictionIn"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <navBar :tags="tags" :title="titleName" :subTitle="subTitle" :btnAdd="false" :btnBack="false"
                @btnAdd="handleAddClick"  @btnBackClick="handleBackClick"/>
        <div style="width: 100%;margin-top: 8px">
            <el-form label-width="120px">
                <el-row>
                    <el-row style="margin-top: 10px">
                        <el-col :span="12">
                            <span  style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">客户
                            </span>
                            <el-input type="text" v-model="customerName" placeholder="请输入医疗机构、门店或经销商名称"
                                      style="width: calc(100% - 120px)">
                            </el-input>

                        </el-col>
                        <el-col :span="12" v-if="this.role!='staff'">
                            <div  style="position: absolute;right: 0;text-align: right">
                            <span
                                    style="line-height: 40px;font-weight: bold;margin-right: 10px;display:
                                    inline-block;width: 60px;">人员</span>
                                <el-select v-if="title !== '管理员'" v-model="selectPeople" clearable
                                           v-on:change="handleSelectInputClick"
                                           :disabled="title !== '管理员'"
                                           placeholder="" style="width: 160px">
                                    <el-option v-for="(item,index) in options" :key="item.user_id"
                                               :label="item.user_name"
                                               :value="item.user_id">
                                    </el-option>
                                </el-select>
                                <inputSelect :handleSelectInput="handleSelectInputClick" v-if="title === '管理员'"></inputSelect>

                            </div>
                        </el-col>

                    </el-row>

                    <el-row>
                        <el-col :span="12" style="position: relative;margin-top: 20px">
                            <span  style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">签入时间
                            </span>
                            <div style="display: inline-block;width: calc(100% - 120px)">
                                <el-date-picker
                                        v-model="checkIn_time"
                                        format="yyyy-M-d"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        style="width:45%"
                                        placeholder="选择日期"

                                >
                                </el-date-picker><span style="display: inline-block;width: 10%;text-align: center">至
                            </span><el-date-picker
                                    v-model="checkInNext_time"
                                    format="yyyy-M-d"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="选择日期"
                                    style="width:45%"
                            >
                            </el-date-picker>
                            </div>

                        </el-col>
                        <el-col :span="12" style="position: relative;margin-top: 20px;text-align: right" >
                            <span  style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">签出时间
                            </span>
                            <div style="display: inline-block;width: calc(100% - 90px)">
                                <el-date-picker
                                        v-model="checkOut_time"
                                        format="yyyy-M-d"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        style="width:45%"
                                        placeholder="选择日期"

                                >
                                </el-date-picker><span style="display: inline-block;width: 10%;text-align: center">至
                            </span><el-date-picker
                                    v-model="checkOutNext_time"
                                    format="yyyy-M-d"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="选择日期"
                                    style="width:45%"
                            >
                            </el-date-picker>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 30px">

                       <span  style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">类型
                        </span>
                            <el-checkbox-group style="display: inline-block" v-model="checkListArray">
                                <el-checkbox label="gps">GPS</el-checkbox>
                                <el-checkbox label="manual">手动</el-checkbox>
                            </el-checkbox-group>


                    </el-row>

                </el-row>

            </el-form>
        </div>
        <el-row style="margin-top:101px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
            <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
            <el-button type="danger" size="small" @click.stop="handleResetClick">重置</el-button>
        </el-row>
        <el-table
                id="JurisdictionIn_table"
                :header-cell-style="{'color':'black','font-size':'15px'}"
                :data="tableData"
                border
                style="width: 100%;margin-top: 20px"
                stripe>
            <el-table-column
                    align="center"
                    type="index"
                    label="序号"
                    width="60px">
            </el-table-column>
            <el-table-column
                    min-width="220"
                    prop="location_name"
                    sortable
                    label="客户"
                    >
            </el-table-column>
            <el-table-column
                    width="230"
                    prop="checkin_time_text"
                    sortable
                    label="签入时间">
                <template slot-scope="scope">
                    <span v-if="scope.row.checkin_time_text ==='尚未签入'" style="color: #ED3B3F">尚未签入</span>
                    <span v-else>{{scope.row.checkin_time_text}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="230"
                    prop="checkout_time_text"
                    sortable
                    label="签出时间">
                <template slot-scope="scope">
                    <span v-if="scope.row.checkout_time_text ==='尚未签出'" style="color: #ED3B3F">尚未签出</span>
                    <span v-else>{{scope.row.checkout_time_text}}</span>
                </template>
            </el-table-column>
<!--            <el-table-column-->
<!--                    width="80"-->
<!--                    prop="retroactive_text"-->
<!--                    sortable-->
<!--                    label="类型">-->
<!--                <template slot-scope="scope">-->
<!--                    <span v-if="scope.row.retroactive_text ==='手动'" style="color: #ED3B3F">{{scope.row.retroactive_text}}</span>-->
<!--                    <span v-else>{{scope.row.retroactive_text}}</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column
                    width="110"
                    prop="last_name"
                    sortable
                    label="销售人员">
            </el-table-column>
            <el-table-column
                    label-class-name="JurisdictionIn_table_cell "
                    fixed="right" label="操作"
                    width="80"
                    style="color: #3b99f7"
            >
                <template slot-scope="scope">
                    <div style="text-align: center">
                        <el-button
                                type="warning" size="small"
                                @click="handleDetail(scope.row)">详情
                        </el-button>
                    </div>

                </template>
            </el-table-column>
        </el-table>
        <el-col style="margin-bottom: 20px">
            <pagination :page="page" @changePage="changePageClick"></pagination>
        </el-col>
    </div>
</template>

<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import pagination from '../../../components/pagination'
    import inputSelect from './components/inputSelect'
    import moment from 'moment'
    export default {
        name: "JurisdictionIn",
        data() {
            return {
                id: "",
                role:'',
                loading: false,
                tags: ['辖区事务'],
                subTitle: '辖区签到',
                tableData: [],
                options:[],
                title:this.$store.getters.getUser.role ==='staff' ? this.$store.getters.getUser.alias:'管理员',
                titleName:this.$store.getters.getUser.role ==='staff' ? this.$store.getters.getUser.alias:this.GLOBAL.peopleName_global,
                selectPeople:this.$store.getters.getUser.user_id,
                selectPeopleManager:'',
                page: this.GLOBAL.page_jurisdictionin,
                meetingName:'',
                key:'',
                meetingAddr:'',
                checkOut_time:'',
                checkOutNext_time:'',
                checkIn_time:'',
                checkInNext_time:'',
                customerName:'',
                hcpName:'',
                options_getMeetingList:[],
                checkListArray:[],
                searchForm:{}
            }
        },
        components: {
            navBar,
            pagination,
            inputSelect
            // Upload
        },
        created () {
            this.role = this.$store.getters.getUser.role
            this.init();
            this.getManager();
            this.getMeetingList();
        },
        mounted () {
            // document.getElementById('main').scrollTo(0, 0)
        },
        methods: {
            async getManager(){
                try {
                    let data={
                        user_id : this.$store.getters.getUser.user_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/Calendar/getManger',data).then(res=>{
                        this.options = res.data
                        let obj={
                            user_id : '',
                            user_name:'所有下属'
                        }
                        this.options.unshift(obj)

                    })
                } catch (e) {

                }
            },
            async getMeetingList(){
                try {
                    let data={
                        user_id : this.$store.getters.getUser.user_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/WeekPlan/getMeetingList',data).then(res=>{
                        this.options_getMeetingList = res.data

                    })
                } catch (e) {

                }
            },
            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser

                    let data={
                        tenant_id : user.tenant_id,
                        user_id : user.user_id,
                        // date : this.date,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        customerName: this.customerName,
                        month : moment(new Date()).format('YYYYMM'),
                        checkListArray : this.checkListArray,
                        checkIn_time: this.checkIn_time ? moment(this.checkIn_time).format('YYYY-MM-DD') : '',
                        checkInNext_time: this.checkInNext_time ? moment(this.checkInNext_time).format('YYYY-MM-DD') : '',
                        checkOutNext_time: this.checkOutNext_time ? moment(this.checkOutNext_time).format('YYYY-MM-DD') : '',
                        checkOut_time: this.checkOut_time ? moment(this.checkOut_time).format('YYYY-MM-DD') : '',
                    }

                    if (user.role == 'staff') {
                        data.owner_id = this.selectPeople
                    }else {
                        data.owner_id = this.GLOBAL.selectPeople_global
                        if(this.GLOBAL.selectOu_global!=''){
                            data.owner_id =''
                            data.ou_id = this.GLOBAL.selectOu_global
                        }
                    }
                    await http.post('/wapi/JurisdictionIn/getCheckList',data).then(res=>{
                        if (res.success === true){

                            this.page.total = res.data.resultCount
                            this.judeg(res.data.result)
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }
            },
            judeg(arr){
                let array = arr

                array.forEach((item,i)=>{
                    item.activity_date= moment(item.activity_date).format('YYYY年M月D日')
                    if (item.checkin_time) {
                        item.checkin_time_text = moment(item.checkin_time).format('YYYY年M月D日 HH:mm:ss')
                        if(item.checkin_retroactive==='T'){
                            item.checkin_time_text = item.checkin_time_text+" (手动)"
                        }else if(item.checkin_retroactive==='F'){
                            item.checkin_time_text = item.checkin_time_text+" (GPS)"
                        }
                    }else {
                        item.checkin_time_text = '尚未签入'
                    }
                    if (item.checkout_time) {
                        item.checkout_time_text = moment(item.checkout_time).format('YYYY年M月D日 HH:mm:ss')
                        if(item.checkout_retroactive==='T'){
                            item.checkout_time_text = item.checkout_time_text+" (手动)"
                        }else if(item.checkout_retroactive==='F'){
                            item.checkout_time_text = item.checkout_time_text+" (GPS)"
                        }
                    }else {
                        item.checkout_time_text = '尚未签出'
                    }
                    // if (item.retroactive === "T"){
                    //     item.retroactive_text = '手动'
                    // } else {
                    //     item.retroactive_text = 'GPS'
                    // }

                })
                this.tableData = array
            },
            handleDetail(row){
                this.GLOBAL.page_jurisdictionin = this.page
                this.searchForm = row
                this.$router.push({name:'jurisdictionInfo',params:row})
            },

            handleSelectInputClick(j){

                for (let i=0;i<this.options.length;i++){

                    if (j === this.options[i].user_id){
                        this.titleName =this.options[i].user_name
                    }
                }
                this.GLOBAL.selectPeople_global = j
                this.titleName = this.GLOBAL.peopleName_global
                this.init()
            },
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.init()
            },
            handleAddClick(){
                // this.$router.push({path:'meetInfo'})
            },
            handleQueryClick(){
                this.page= {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.init()
            },
            handleResetClick(){
            this.checkOut_time =''
            this.checkInNext_time =''
            this.checkIn_time =''
            this.checkOutNext_time =''
            this.checkListArray = []
            this.customerName = ''
            }

        },
        beforeRouteLeave(to, from, next){

            // 打开详情页（或者下一个任意界面）之前，把筛选条件保存到localStorage，如果离开列表页并且打开的不是详情页则清除，也可以选择不清除
            if (to.name === 'jurisdictionInfo') {
                // console.log(this.searchForm)
                let condition = JSON.stringify(this.searchForm)
                localStorage.setItem('condition', condition)
            }else{
                localStorage.removeItem('condition')
            }
            if (to.name !== 'jurisdictionInfo'){
                this.GLOBAL.page_jurisdictionin = {
                    current: 1,
                    size: 5,
                    total: 0
                }
            }
            next()
        }
    }
</script>

<style>
    #JurisdictionIn_table th{
        padding: 7px 0;
    }
</style>
<style scoped>
    #JurisdictionIn >>> .JurisdictionIn_table_cell {
        color: #2b92fa !important;
    }
    #JurisdictionIn >>> .el-button--warning {
        color: #FFF;
        background-color: #FF9901;
        border-color: #FF9901;
    }
    #JurisdictionInx >>> .el-button--warning:hover {
        background: #ebb563;
        border-color: #ebb563;
        color: #FFF;
    }
    #JurisdictionIn >>> .el-button{
        font-size: 13px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/calendar/components/JurisdictionIn.vue